import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { MENU_TOGGLE_STATE_LANGUAGE } from '../global-navigation.constant';

@Component({
  selector: 'app-global-navigation-hindi',
  templateUrl: './global-navigation-hindi.component.html',
  styleUrls: ['./global-navigation-hindi.components.scss']

})
export class GlobalNavigationHindiComponent implements OnInit {

  public menuToggleStateLabelHindi = MENU_TOGGLE_STATE_LANGUAGE.hindi;
  public currentRoute: any;
  public menuExpandCollapse: boolean = true;

  public menuListHindi: { menuTitle: string, routerLink: string, menuSubTitle?: string, menuIndicator?: number | string, isDisable?: boolean, cssClass: string[] }[] = [
    { menuTitle: 'नियंत्रण-पट्ट', routerLink: '/dashboard', cssClass: ['icon-lms-dashboard', 'icon-lms-dashboard-fill'] },
    { menuTitle: 'पाठ्यक्रम', routerLink: '/courses', menuSubTitle: 'Gateway A1+', cssClass: ['icon-course', 'icon-course-full'] },
    { menuTitle: 'कक्षाओं', routerLink: '/classes', cssClass: ['icon-my-classes', 'icon-my-classes-full'] },
    { menuTitle: 'पंचांग', routerLink: '/calendar', cssClass: ['icon-calendar', 'icon-calendar-full'] },
    { menuTitle: 'उत्पादों', routerLink: '/products', cssClass: ['icon-lms-products', 'icon-lms-products-fill'] },
    { menuTitle: 'उपयोगकर्ताओं', routerLink: '/users', cssClass: ['icon-lms-users', 'icon-lms-users_fill'] },
    { menuTitle: 'पुस्तक', routerLink: '/book', menuSubTitle: 'Student Book', cssClass: ['icon-book', 'icon-book-full'] },
    { menuTitle: 'विषयसूची', routerLink: '/tableofContents', cssClass: ['icon-bookshelf', 'icon-bookshelf_fill'] },
    { menuTitle: 'चुनौती', routerLink: '/challenge', menuIndicator: 'Beta', cssClass: ['icon-challenge', 'icon-challenge-full'] },
    { menuTitle: 'घर का पाठ', routerLink: '/homework', cssClass: ['icon-homework', 'icon-homework-full'] },
    { menuTitle: 'आकलन', routerLink: '/assessments', menuIndicator: 'Beta', cssClass: ['icon-lms-assessments', 'icon-assessments-full'] },
    { menuTitle: 'विवरण', routerLink: '/reports', cssClass: ['icon-lms-reports', 'icon-lms-reports-fill'] },
    { menuTitle: 'संदेश', routerLink: '/messages', menuIndicator: 101, cssClass: ['icon-message-dots-circle', 'icon-message-dots-circle-fill'] },
    { menuTitle: 'अधिसूचना', routerLink: '/notification', menuIndicator: 10, isDisable: true, cssClass: ['icon-lms-notification', 'icon-lms-notifications-fill'] },
    { menuTitle: 'मेरी प्रोफाइल', routerLink: '/profile', cssClass: ['icon-profile', 'icon-profile-full'] },
    { menuTitle: 'मदद', routerLink: '/help', cssClass: ['icon-help', 'icon-help-full'] },
    { menuTitle: 'लॉग आउट', routerLink: '/logout', cssClass: ['icon-lms-logout', 'icon-lms-logout-fill'] },
    { menuTitle: 'अधिक', routerLink: '/more', cssClass: ['icon-dots-vertical', 'icon-more-full'] }
  ];

  constructor(private activatedRoute: ActivatedRoute, private _router: Router) { }

  ngOnInit() {

    this._router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url.split('?')[0];
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      if (params && params['isOpened']) {
        this.menuExpandCollapse = (params['isOpened'] == 'true');
      }
      if (params && params['menuExpandCollapse']) {
        if (params['menuExpandCollapse'] == 'true') {
          this.menuExpandCollapse = false;
        } else {
          this.menuExpandCollapse = true;
        }
      }
    });
  }

}